module.exports = __webpack_public_path__ + "static/img/cha1.a62c8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha1.png
// module id = nGSZ
// module chunks = 1